import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { fuseAnimations } from "@fuse/animations";
import { StatusCartaConsorcioModel } from "app/auxiliares/models/status-carta-consorcio.model";
import { StatusCartaConsorcioService } from "app/auxiliares/services/status-carta-consorcio-service";
import { BaseComponent } from "app/base-module/base-component/base.component";
import { AuthService } from "app/base-module/base-service/auth.service";
import { Usuario } from "app/usuarios/models/user.model";

@Component({
    selector: "filtro-carta-boleta-consorcio",
    templateUrl: "./filtro-carta-boleta-consorcio.component.html",
    styleUrls: ["./filtro-carta-boleta-consorcio.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [],
})
export class FiltroCartaBoletaConsorcioComponent extends BaseComponent implements OnInit {
    model: {
        status_id: string;
        grupo: string;
        cota: string;
    } = {
        status_id: "",
        grupo: "",
        cota: "",
    };

    titulo: string = "Filtrar Cartas";
    usuario: Usuario | null = null;
    listStatusCartaConsorcio: StatusCartaConsorcioModel[] = [];
    loadingSpinnerStatusCartaConsorcio: boolean = false;

    @ViewChild("addButtonTmpl", { static: false }) addButtonTmpl!: TemplateRef<any>;
    @ViewChild(FiltroCartaBoletaConsorcioComponent, { static: false }) table!: FiltroCartaBoletaConsorcioComponent;

    formGroup!: FormGroup;

    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<FiltroCartaBoletaConsorcioComponent>,
        private _authService: AuthService,
        private _statusCartaService: StatusCartaConsorcioService,
        private fb: FormBuilder
    ) {
        super(dialog, snackBar);
        const strUser = this._authService.getUser();
        this.usuario = JSON.parse(strUser ? strUser : "{}");
    }

    /**
     * Inicialização do componente
     * @returns {void}
     */
    ngOnInit(): void {
        this.formGroup = this.fb.group({
            grupo: new FormControl(),
            cota: new FormControl(),
            status_id: new FormControl(),
        });
        this.getAllStatusCarta();
    }

    /**
     * Função de exibição para autocomplete de cliente
     * @param {unknown} cliente - Cliente selecionado
     * @returns {string} Nome do cliente ou string vazia
     */
    displayFn(cliente: unknown): string {
        if (cliente) {
            return (cliente as { nome: string }).nome;
        }
        return "";
    }

    /**
     * Fecha o diálogo cancelando a operação
     * @returns {void}
     */
    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    /**
     * Aplica os filtros e fecha o diálogo
     * @returns {void}
     */
    filtrar(): void {
        this.dialogRef.close(this.formGroup.value);
    }

    /**
     * Consulta lista de status da carta
     * @returns {void}
     */
    getAllStatusCarta(): void {
        this.loadingSpinnerStatusCartaConsorcio = true;
        this._statusCartaService.getAll({ no_paginate: true }).subscribe({
            next: (list) => {
                this.listStatusCartaConsorcio = list.data;
            },
            error: (error) => {
                this.loadingSpinnerStatusCartaConsorcio = false;
                this.showError(`Erro ao buscar status: ${error.error?.message || error.message}`);
            },
            complete: () => {
                this.loadingSpinnerStatusCartaConsorcio = false;
            },
        });
    }
}
